import { toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  style: {
    "line-height": "30px"
  }
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_4 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_5 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_6 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_7 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_8 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_9 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_10 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_13 = {
  key: 2
};
const _hoisted_14 = {
  key: 3
};
const _hoisted_15 = {
  key: 4
};
const _hoisted_16 = {
  style: {
    "padding": "0px 10px"
  }
};
const _hoisted_17 = {
  style: {
    "padding": "0px 10px"
  }
};
const _hoisted_18 = {
  key: 5
};
const _hoisted_19 = {
  style: {
    "padding": "0px 10px"
  }
};
const _hoisted_20 = {
  key: 6
};
const _hoisted_21 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_22 = {
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_23 = {
  key: 7
};
const _hoisted_24 = {
  style: {
    "padding": "5px 10px"
  }
};
const _hoisted_25 = {
  style: {
    "padding": "5px 10px"
  }
};
const _hoisted_26 = {
  key: 8
};
const _hoisted_27 = {
  key: 0,
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_28 = {
  key: 1,
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_29 = {
  key: 2,
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_30 = {
  key: 3,
  style: {
    "padding": "0 10px"
  }
};
const _hoisted_31 = {
  key: 0,
  class: "voca-box"
};
const _hoisted_32 = {
  class: "dialog-footer"
};
const _hoisted_33 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_dialog, {
    class: "examInfo-dialog",
    modelValue: $setup.examInfoShow,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $setup.examInfoShow = $event),
    title: "考试须知",
    width: "60%",
    height: "60%",
    "close-on-click-modal": false,
    "show-close": false,
    "close-on-press-escape": false,
    center: ""
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_32, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $setup.startExam,
      loading: $setup.startExamFlag
    }, {
      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [_createTextVNode("开始考试", -1)]))]),
      _: 1
    }, 8, ["onClick", "loading"])])]),
    default: _withCtx(() => [_withDirectives(_createElementVNode("ul", _hoisted_1, [_withDirectives(_createElementVNode("li", {
      style: {
        "font-weight": "700"
      }
    }, " · 考查技能：" + _toDisplayString($setup.store.state.skill[$props.examInfo.skill]), 513), [[_vShow, $props.examInfo.examType != 3]]), _withDirectives(_createElementVNode("li", null, [_cache[24] || (_cache[24] = _createElementVNode("span", {
      style: {
        "font-weight": "700"
      }
    }, "· 考试说明：", -1)), $props.examInfo.skill == 'S0' && $setup.step == 0 ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [_withDirectives(_createElementVNode("li", _hoisted_3, " 1. 词汇测试：约15min ", 512), [[_vShow, !$setup.route.meta.trial]]), _withDirectives(_createElementVNode("li", _hoisted_4, " 2. 词缀测试：约5min ", 512), [[_vShow, !$setup.route.meta.trial]]), _withDirectives(_createElementVNode("li", _hoisted_5, " 3. 词汇搭配与用法测试：约10min ", 512), [[_vShow, !$setup.route.meta.trial]]), _withDirectives(_createElementVNode("li", _hoisted_6, " 在测试中，Section Ⅰ（词汇测试）和 Section Ⅱ（词缀测试）为自适应测试，试题不可返回修改。 ", 512), [[_vShow, !$setup.route.meta.trial]]), _withDirectives(_createElementVNode("li", _hoisted_7, " Section Ⅲ （词汇搭配与用法测试）的试题可返回修改，也可根据题号选择作答或修改。 ", 512), [[_vShow, !$setup.route.meta.trial]]), _withDirectives(_createElementVNode("li", _hoisted_8, " 为了保证词汇测试的准确性，请务必认真作答每道词汇诊断题目。 ", 512), [[_vShow, !$setup.route.meta.trial]]), _withDirectives(_createElementVNode("li", _hoisted_9, " 词汇诊断测试包含三部分：词汇测试、词缀测试、词汇搭配与用法测试。 ", 512), [[_vShow, $setup.route.meta.trial]]), _withDirectives(_createElementVNode("li", _hoisted_10, " 快速体验中遇到得提醒将会是您未来正式考试中的题型，请您认真阅读指令语快速熟悉题型。 ", 512), [[_vShow, $setup.route.meta.trial]])])) : $props.examInfo.skill == 'S1' || $props.examInfo.skill == 'S9' ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [_createElementVNode("li", _hoisted_12, [_cache[11] || (_cache[11] = _createTextVNode(" 点击图标 ", -1)), _withDirectives(_createElementVNode("div", {
      class: "icon play-icon loading-ani",
      onClick: _cache[0] || (_cache[0] = (...args) => $setup.audioStop && $setup.audioStop(...args))
    }, null, 512), [[_vShow, $setup.videoStatus == 'ing']]), _withDirectives(_createElementVNode("div", {
      class: "icon pause-icon-text",
      onClick: _cache[1] || (_cache[1] = (...args) => $setup.audioPlay && $setup.audioPlay(...args))
    }, null, 512), [[_vShow, $setup.videoStatus == 'stop']]), _cache[12] || (_cache[12] = _createTextVNode(" 检测您的设备是否能听到声音并及时调节音量。 ", -1))])])) : $props.examInfo.skill == 'S4' && !$setup.route.meta.trial ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [...(_cache[13] || (_cache[13] = [_createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "1. 写前自评", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "2. 间接写作(20min)", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "3. 直接写作", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "4. 写后自评一", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "5. 写后自评二", -1)]))])) : $props.examInfo.skill == 'S4' && $setup.route.meta.trial ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [...(_cache[14] || (_cache[14] = [_createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "1. 写前自评", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "2. 间接写作", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "3. 直接写作", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "4. 写后自评一", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "5. 写后自评二", -1), _createElementVNode("li", null, "请根据测试时长合理安排作答时间", -1)]))])) : $props.examInfo.skill == 'S5' && $props.examInfo.examType != 3 ? (_openBlock(), _createElementBlock("ul", _hoisted_15, [_cache[15] || (_cache[15] = _createElementVNode("li", {
      style: {
        "padding": "0px 10px"
      }
    }, "1. 考前自评", -1)), _withDirectives(_createElementVNode("li", _hoisted_16, " 2. 口语考试（5项任务） ", 512), [[_vShow, !$setup.route.meta.trial]]), _withDirectives(_createElementVNode("li", _hoisted_17, " 2. 口语考试（3项任务） ", 512), [[_vShow, $setup.route.meta.trial]]), _cache[16] || (_cache[16] = _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "3. 考后自评", -1)), _cache[17] || (_cache[17] = _createElementVNode("li", {
      style: {
        "padding": "0px 10px"
      }
    }, " 每项任务开始后系统自动播放题目音频，音频播放后页面出现“开始作答”的提示，点击“OK”键开始作答。 ", -1)), _cache[18] || (_cache[18] = _createElementVNode("li", {
      style: {
        "padding": "0px 10px"
      }
    }, " 每项任务作答结束后点击“NEXT”键，进入下一题，无法暂停或返回上一题。 ", -1)), _cache[19] || (_cache[19] = _createElementVNode("li", {
      style: {
        "padding": "0px 10px"
      }
    }, " 每项任务仅有一次作答机会，注意安排好作答时间。 ", -1))])) : $props.examInfo.skill == 'S5' && $props.examInfo.examType == 3 ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [_withDirectives(_createElementVNode("li", _hoisted_19, " 口语考试（5项任务） ", 512), [[_vShow, !$setup.route.meta.trial]]), _cache[20] || (_cache[20] = _createElementVNode("li", {
      style: {
        "padding": "0px 10px"
      }
    }, " 每项任务开始后系统自动播放题目音频，音频播放后页面出现“开始作答”的提示，点击“OK”键开始作答。 ", -1)), _cache[21] || (_cache[21] = _createElementVNode("li", {
      style: {
        "padding": "0px 10px"
      }
    }, " 每项任务作答结束后点击“NEXT”键，进入下一题，无法暂停或返回上一题。 ", -1)), _cache[22] || (_cache[22] = _createElementVNode("li", {
      style: {
        "padding": "0px 10px"
      }
    }, " 每项任务仅有一次作答机会，注意安排好作答时间。 ", -1))])) : $props.examInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [_withDirectives(_createElementVNode("li", _hoisted_21, " 考试中“Fast reading”部分需在15分钟内做完，请把握好作答时间。 ", 512), [[_vShow, $props.examInfo.papers[0].level * 1 > 4]]), _withDirectives(_createElementVNode("li", _hoisted_22, " 本次阅读测试是由水平探测和诊断测试组成的，请确保所有题目作答完毕后提交试卷。 ", 512), [[_vShow, $props.examInfo.totalTime / 60 > 70]])])) : _createCommentVNode("", true), $props.examInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("ul", _hoisted_23, [_withDirectives(_createElementVNode("li", _hoisted_24, " 考试中“Fast reading”部分需在15分钟内做完，请把握好作答时间。 ", 512), [[_vShow, $props.examInfo.papers[0].level * 1 > 4]]), _withDirectives(_createElementVNode("li", _hoisted_25, " 本次阅读测试是由水平探测和诊断测试组成的，请确保所有题目作答完毕后提交试卷。 ", 512), [[_vShow, $props.examInfo.totalTime / 60 > 60]])])) : $props.examInfo.skill == 'bsd' ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [...(_cache[23] || (_cache[23] = [_createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "1. 考试共分为听力、词汇、阅读三部分。", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "2. 听力部分共四个小节。", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "    第一小节，听一遍对话，选择正确的答案。 ", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "    第二小节，听一遍新闻，选择正确的答案。 ", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, "    第三小节，听两遍讲座，填写答案完成讲座提纲。 ", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, " 3. 词汇部分共10道小题，请选择正确的答案 ", -1), _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, " 4. 阅读部分共三个部分，四篇文章，请选择正确的答案。 ", -1), _createElementVNode("li", null, "请根据测试时长合理安排作答时间", -1)]))])) : _createCommentVNode("", true)], 512), [[_vShow, !($props.examInfo.examType == 3 || $props.examInfo.skill == 'S3' || $props.examInfo.totalTime / 60 <= 60 && $props.examInfo.papers[0].level * 1 <= 4 && $props.examInfo.skill == 'S2')]]), _cache[25] || (_cache[25] = _createElementVNode("li", {
      style: {
        "font-weight": "700"
      }
    }, "· 注意事项：", -1)), _cache[26] || (_cache[26] = _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, " 考试前请检查您的浏览器，为保证顺畅的作答体验，请您尽量使用谷歌或者火狐浏览器。 ", -1)), _cache[27] || (_cache[27] = _createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, " 考试期间不可中断考试，不可访问其他网页或刷新考试页面。 ", -1)), $props.examInfo.skill == 'S4' && $setup.route.meta.trial ? (_openBlock(), _createElementBlock("li", _hoisted_27, " 考试时间为45分钟，请合理安排考试时间！ ")) : $props.examInfo.skill == 'S4' ? (_openBlock(), _createElementBlock("li", _hoisted_28, " 考试时间为" + _toDisplayString($setup.writeTime) + "分钟，请合理安排考试时间！ ", 1)) : $setup.route.path == '/exam/oralq' ? (_openBlock(), _createElementBlock("li", _hoisted_29, " 考试时间为" + _toDisplayString($props.examInfo.papers[1].duration / 60) + "分钟，请合理安排考试时间！ ", 1)) : $props.examInfo.skill != 'S0' ? (_openBlock(), _createElementBlock("li", _hoisted_30, " 考试时间为" + _toDisplayString($props.examInfo.totalTime / 60) + "分钟，请合理安排考试时间！ ", 1)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("li", {
      style: {
        "padding": "0 10px"
      }
    }, _toDisplayString($setup.skillText[$props.examInfo.skill]), 513), [[_vShow, $props.examInfo.examType != 3]])], 512), [[_vShow, $setup.step == 0]]), $setup.step == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_cache[32] || (_cache[32] = _createElementVNode("p", null, " 亲爱的同学您好，在开始词汇诊断之前，我们想了解一下您之前是否做过词汇量方面的测试、在哪进行的词汇量测试、结果如何？ ", -1)), _createVNode(_component_el_radio, {
      modelValue: $setup.vocaMsg.ifJoin,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.vocaMsg.ifJoin = $event),
      label: "1",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode("是，我参加过 ", -1)]))]),
      _: 1
    }, 8, ["modelValue"]), _createVNode(_component_el_radio, {
      modelValue: $setup.vocaMsg.ifJoin,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.vocaMsg.ifJoin = $event),
      label: "2",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [_createTextVNode("否，我没参加过 ", -1)]))]),
      _: 1
    }, 8, ["modelValue"]), _withDirectives(_createElementVNode("p", null, "1. 请填写在哪个平台或APP做的词汇量测试", 512), [[_vShow, $setup.vocaMsg.ifJoin == 1]]), _withDirectives(_createElementVNode("input", {
      class: "S0-input",
      type: "text",
      placeholder: "请填写平台名",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.vocaMsg.appName = $event)
    }, null, 512), [[_vShow, $setup.vocaMsg.ifJoin == 1], [_vModelText, $setup.vocaMsg.appName]]), _withDirectives(_createElementVNode("p", null, "2. 请选择词汇量测试结果", 512), [[_vShow, $setup.vocaMsg.ifJoin == 1]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_radio, {
      style: {
        "width": "120px"
      },
      modelValue: $setup.vocaMsg.vocabValue,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.vocaMsg.vocabValue = $event),
      label: "2000以下",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[30] || (_cache[30] = [_createTextVNode("2000以下 ", -1)]))]),
      _: 1
    }, 8, ["modelValue"]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, num => {
      return _withDirectives(_createVNode(_component_el_radio, {
        style: {
          "width": "120px"
        },
        key: 'voca' + num,
        modelValue: $setup.vocaMsg.vocabValue,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.vocaMsg.vocabValue = $event),
        label: 2000 + num * 500 + '-' + (2500 + num * 500),
        size: "large"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(2000 + num * 500) + "-" + _toDisplayString(2500 + num * 500), 1)]),
        _: 2
      }, 1032, ["modelValue", "label"]), [[_vShow, $setup.vocaMsg.ifJoin == 1]]);
    }), 64)), _createVNode(_component_el_radio, {
      style: {
        "width": "120px"
      },
      modelValue: $setup.vocaMsg.vocabValue,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $setup.vocaMsg.vocabValue = $event),
      label: "12000以上",
      size: "large"
    }, {
      default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("12000以上 ", -1)]))]),
      _: 1
    }, 8, ["modelValue"])], 512), [[_vShow, $setup.vocaMsg.ifJoin == 1]])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("audio", {
    id: "audio",
    src: $setup.mp3,
    onEnded: _cache[9] || (_cache[9] = $event => $setup.videoStatus = 'stop'),
    onPause: _cache[10] || (_cache[10] = $event => $setup.videoStatus = 'stop'),
    controls: "",
    style: {
      "display": "none"
    },
    preload: "none"
  }, null, 40, _hoisted_33)], 64);
}